module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA8CAYAAABxVAqfAAAABHNCSVQICAgIfAhkiAAAAQtJREFUWIXt1rFqAkEQxvH/HT7ANXYK19mmt9BXiI1l8A1sFQKBgD6GSKo0+gIhXIrUqe0OtLO5N5gUBymuut0d9wzM1Mv+mGXmYxMReQCmQEacqoAiEZFlRPQPTztAAbK0AxQAgw022GCDDTb4H8GrHZPZK0/R4Y8fpucruRbeGl7P2QNo4a3hxzGlJu40XJq481Rr4V7rpIF773EoHhQgIXhwcjXx1Y5JFLhZpwt5FPj4Tb55r5942Kc8PNfd3xT2RYPgENQbDkW9YA3UGdZCnWBN1Al++6yDQQMF6LU9OBpQjgaU2wVfoShAIiIvGhe51v3/Mg022GCDDTbY4JvCVQdulQJFZLwCil/4wn1ovMDHjQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ds-img/向右.png
// module id = R8zj
// module chunks = 2